import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Cards.css';
import QuestionIcon from '../QuestionIcon/QuestionIcon';

class Cards extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  static propTypes = {
    contents: PropTypes.arrayOf(
      PropTypes.shape({
        uniqueId: PropTypes.string.isRequired,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        subText: PropTypes.string,
        moreInfoTooltip: PropTypes.string,
        cardFooterComponent: PropTypes.element
      })
    ).isRequired
  };

  render() {
    return <div className="customCards">{this.displayCards(this.props.contents)}</div>;
  }

  displayCards = contents => {
    return contents.map(key => (
      <div key={key.uniqueId} className="card cardDisplay">
        <div className="card-body cardBorder">
          {key.moreInfoTooltip && (
            <div className="infoIcon">
              <QuestionIcon id={key.uniqueId} tooltipInfo={key.moreInfoTooltip} />
            </div>
          )}
          <div className="card-title cardOutline">
            <div className="cardKPIs">
              <div className="cardTitleText">{key.title}</div>
              <div className="subTextDetails">{key.subText}</div>
              <div>{key.cardFooterComponent}</div>
            </div>
          </div>
        </div>
      </div>
    ));
  };
}

export default Cards;



// WEBPACK FOOTER //
// ./src/Components/Cards/Cards.js